import { createStore } from 'vuex';
import topup from "./modules/topup";
import datapack from "./modules/datapack";
import egiftcard from "./modules/egiftcard";
import newandpromo from './modules/newandpromo';
import topupadd from './modules/topupadd';
import datapackadd from './modules/datapackadd';
import faq from './modules/faq';

const store = createStore({
  modules: {
    topup,
    datapack,
    egiftcard,
    newandpromo,
    topupadd,
    datapackadd,
    faq
  },
  state() {},
  getters: {},
  actions: {},
  mutations: {},
});

export default store;
